// Helpers partagés du centre de notifications (WKF-013).

import { API_BASE } from '@/lib/api'
import { extractStructuredApiError } from '@/lib/api-error'

export const NOTIF_BASE = `${API_BASE}/notifications`
export const TASKS_BASE = `${API_BASE}/tasks`

export async function readError(resp: Response): Promise<Error> {
    let payload: unknown = {}
    try {
        payload = await resp.json()
    } catch {
        /* ignore */
    }
    const { message, code } = extractStructuredApiError(payload)
    const err = new Error(message || `Erreur ${resp.status}`) as Error & {
        code?: string
        httpStatus?: number
    }
    err.code = code && code !== 'UNKNOWN' ? code : `HTTP_${resp.status}`
    err.httpStatus = resp.status
    return err
}

export function jsonHeaders(entityId: string): HeadersInit {
    return { 'Content-Type': 'application/json', 'X-Entity-Id': entityId }
}

export function entityHeaders(entityId: string): HeadersInit {
    return { 'X-Entity-Id': entityId }
}

/** Construit une query string à partir d'un objet (ignore les valeurs vides). */
export function buildQuery(params: Record<string, unknown>): string {
    const sp = new URLSearchParams()
    for (const [key, value] of Object.entries(params)) {
        if (value === undefined || value === null || value === '') continue
        sp.set(key, String(value))
    }
    const s = sp.toString()
    return s ? `?${s}` : ''
}
